'use client'
import React, { ReactElement, useContext } from 'react'
import { Column } from '../../../../types'
import { FilterContext } from '../../../../providers/filter-provider'
import { SortingDirection } from '../../../../types/Sorting'
import {
    FilteredAndSortedAscendingIcon,
    FilteredAndSortedDescendingIcon,
    FilterIcon,
    ArrowDownIcon,
    ArrowUpIcon,
} from '../../../icons'

interface TableHeaderCellIconProps {
    column?: Column
}

const DEFAULT_HEADER_CELL_ICON = <span className="w-6 h-6" />

export const TableHeaderCellIcon = ({ column }: TableHeaderCellIconProps): ReactElement => {
    if (!column) return DEFAULT_HEADER_CELL_ICON
    const filterContext = useContext(FilterContext)

    const columnIsFiltered = !!column.filterBy && !!filterContext?.hasFilterForKey(column.filterBy)

    if (columnIsFiltered) {
        switch (column?.sortDirection) {
            case SortingDirection.ASCENDING:
                return <FilteredAndSortedAscendingIcon />
            case SortingDirection.DESCENDING:
                return <FilteredAndSortedDescendingIcon />
            default:
                return <FilterIcon />
        }
    } else {
        switch (column?.sortDirection) {
            case SortingDirection.ASCENDING:
                return <ArrowDownIcon />
            case SortingDirection.DESCENDING:
                return <ArrowUpIcon />
            default:
                return DEFAULT_HEADER_CELL_ICON
        }
    }
}
